import React, { Component } from 'react';
import done_green from '../images/done-green.svg';
import '../styles/Success.scss';
import Footer from './Footer';
import SideBar from './SideBar';
import Header from './Header';
import { withTranslation } from 'react-i18next';
import { Auth } from 'aws-amplify';

let gatsbyApplicationUrl = process.env.REACT_APP_GATSBY_APPLICATION_URL;
let logipulseApplicationUrl = process.env.REACT_APP_LOGIPULSE_APPLICATION_URL;

class Success extends Component {

    navigateToApplication = async (event) => {
        let currentLanguage = localStorage.getItem("languageCode");
        let user = await Auth.currentAuthenticatedUser();
        let userAttributes = await Auth.currentUserInfo(user);
        let userRole = userAttributes.attributes['custom:tenantUserRole'];
        event.preventDefault();

        if (((userRole === 'TenantAdmin') || (userRole === 'SystemAdmin'))) {
            if (currentLanguage === 'en') {
                window.location.replace(`${gatsbyApplicationUrl}/location`);
            }
            else {
                window.location.replace(`${gatsbyApplicationUrl}/${currentLanguage}/location`);
            }
        } else {
            window.location.replace(`${logipulseApplicationUrl}/logipulse/mail/inbox`);
        }
    }

    render() {
        const { t } = this.props;
        return (
            <main className="Dash-board">
                <div className="Dash-board-div">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-3">
                                <SideBar {...this.props} />
                            </div>
                            <div className="col-md-9">
                                <Header {...this.props} />
                                <div className="success-content-sec">
                                    <div className="success-cont text-center">
                                        <div className="circle">
                                            <img src={done_green} alt="" />
                                        </div>
                                        <h3>{t('Success !')}</h3>
                                        <div className="align-nav-btn">
                                            <div className="navigation-btn" onClick={() => { this.props.history.push('/Summary') }}>{t('GO TO SUMMARY')}</div>
                                            <div className="navigation-btn" onClick={this.navigateToApplication}>{t('GO TO APPLICATION')}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </main>

        )
    }
}
export default withTranslation()(Success)